import { FormattedMessage } from 'react-intl';

import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';

import { messages } from './messages';
import { useOrdersSidebarPickupInformationSection } from './use-orders-sidebar-pickup-information-section';
import PickupInformationByFulfillmentPlanId from '../../../../fulfillment-planner/local-delivery/pickup-information/by-fulfillment-plan-id';

/**
 * @param {object} props
 * @param {string} props.currentFulfillmentPlanId
 * @param {object} props.dragHandleProps
 * @returns {JSX.Element}
 */
export const PickupInformation = ({ currentFulfillmentPlanId: fulfillmentPlanId, dragHandleProps }) => {
  const { isLocalDelivery, open, toggleCollapsableSection } = useOrdersSidebarPickupInformationSection();

  return (
    isLocalDelivery && (
      <CollapsibleListSection open={open}>
        <CollapsibleListSectionHeader dragHandleProps={dragHandleProps} onClick={toggleCollapsableSection} theme='white'>
          <FormattedMessage {...messages.pickupInformation} />
        </CollapsibleListSectionHeader>
        <CollapsibleListSectionContent>
          <PickupInformationByFulfillmentPlanId fulfillmentPlanId={fulfillmentPlanId} />
        </CollapsibleListSectionContent>
      </CollapsibleListSection>
    )
  );
};
